// Libraries
var React = require('react');

// Components
var OptaWidget = require('../OptaWidget/OptaWidget');

// Styles
require('./MatchHeatmap.scss');

class MatchHeatmapModule extends React.Component {
    
	render() {
        return (
            <div className="MatchHeatmap">
                <h2>Heatmap</h2>
                <OptaWidget language={this.props.data.language} timezone={this.props.data.timezone} subscriptionId={this.props.data.subscriptionId} properties={this.props.data.properties}/>
            </div>)
    }
}
    
module.exports = MatchHeatmapModule;


// WEBPACK FOOTER //
// ./src/components/MDC/MatchHeatmap/MatchHeatmapModule.js